export interface CommonBaseState {
    loading: boolean;
    loadingItem: boolean;
    deleting: boolean;
    saving: boolean;

    error: boolean;
    errorMessage?: string;
}

export const initialCommonBaseState: CommonBaseState ={
    loading: false,
    loadingItem: false,
    deleting: false,
    saving: false,
    error: false,
}
